import getClient from "src/services/contentful/contentful";

import {
  IPageBlogIndexFields,
  IPostFields,
} from "src/types/generated/contentful";
import getTags from "src/services/contentful/tag/getTags";

import { PostParsed } from "./postParser";

// export default async function getPreviewPostBySlug(
//   slug: string,
// ): Promise<PostParsed> {
//   const [entry] = await getPostEntries({
//     preview: true,
//     query: {
//       limit: 1,
//       'fields.slug[in]': slug,
//     },
//     includeContent: true,
//   })

//   return entry
// }

export default async function getBlogIndexEntry({
  query,
  preview = false,
  includeContent = false,
}: any): Promise<any> {
  const entries = await getClient({ preview }).getEntries({
    content_type: "page",
    "fields.content.sys.contentType.sys.id": "pageBlogIndex",
    ...query,
    include: includeContent ? 10 : 1,
  });
  return entries.items[0];
}
